class MainCollection extends HTMLElement {
    constructor() {
        super();

        this.querySelectorAll("[data-add-to-cart-decouverte]").forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault();
                const productId = element.getAttribute("data-add-to-cart-decouverte");
                this.addToCart(productId);
            });
        });

        this.updateCustomImages();

        window.addEventListener('resize', () => {
            this.updateCustomImages();
        });

        document.querySelectorAll('.main-collection__toogle').forEach((element) => {
            let old_height = element.offsetHeight;
            element.style.height = old_height + 'px';
        });

        //  one click one main-collection__toogle-text display all the text and hide the button 

        document.querySelectorAll('.main-collection__toogle').forEach((element) => {
            let old_height = element.offsetHeight;
            element.addEventListener('click', (event) => {
                // calcule the height of the text when it's all displayed
                if (element.querySelector('.main-collection__toogle-text').classList.contains('active')) {
                    element.querySelector('.main-collection__toogle-text').classList.remove('active');
                    element.classList.remove('active');
                    element.style.height = old_height + 'px';
                } else {
                    let height = element.querySelector('.main-collection__toogle__custom').offsetHeight;
                    element.style.height = height + 'px';
                    element.classList.add('active');
                    element.querySelector('.main-collection__toogle-text').classList.add('active');
                }

            });
        });

        document.querySelectorAll('.filter-opener__button').forEach((element) => {
            element.addEventListener('click', (event) => {
                this.openFilters();
            });
        })

        //  if click outside of the filters
        document.addEventListener('click', (event) => {
            if (!event.target.closest('.main-collection__filters') && !event.target.closest('.filter-opener__button')) {
                document.body.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden-filters');
                document.querySelector('.main-collection__filters').classList.remove('actif');
            }
        });

        document.querySelectorAll('.filtre__footer__button').forEach((element) => {
            element.addEventListener('click', (event) => {
                document.body.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden-filters');
                document.querySelector('.main-collection__filters').classList.remove('actif');
            });
        });
        document.querySelectorAll('.close--button').forEach((element) => {
            element.addEventListener('click', (event) => {
                document.body.classList.remove('overflow-hidden');
                document.body.classList.remove('overflow-hidden-filters');
                document.querySelector('.main-collection__filters').classList.remove('actif');
            });
        });

        this.querySelectorAll('.main-collection__filters [data-handle]').forEach((element) => {
            element.addEventListener('click', (event) => {
                let handle = element.getAttribute('data-handle');

                this.querySelectorAll('.main-collection__filters [data-handle]').forEach((element) => {
                    element.classList.remove('actif');
                });

                element.classList.add('actif');

                document.querySelectorAll('[data-categorie-name]').forEach((subelement) => {
                    subelement.textContent = element.querySelector('.content').textContent;
                });

                if (handle == 'all') {
                    document.querySelectorAll('.pack-list__slide:not(.custom-image)').forEach((element) => {
                        element.classList.remove('hidden');
                    });
                } else {
                    document.querySelectorAll('.pack-list__slide:not(.custom-image)').forEach((element) => {
                        element.classList.add('hidden');
                    });

                    document.querySelectorAll('.pack-list__slide [data-filter]').forEach((element) => {
                        let filters = element.getAttribute('data-filter').split(',');

                        for (let i = 0; i < filters.length; i++) {
                            let filter = filters[i].toString().replace(/\s/g, '');
                            console.log(filter);
                            console.log(handle);
                            if (filter == handle) {
                                element.closest('.pack-list__slide:not(.custom-image)').classList.remove('hidden');
                            }
                        }
                    });
                }
                this.updateCustomImages();
                this.querySelectorAll('.main-collection-block').forEach((element) => {
                    let all_hidden = true;
                    element.querySelectorAll('.pack-list__slide:not(.custom-image)').forEach((subElement) => {
                        if (!subElement.classList.contains('hidden')) {
                            all_hidden = false;
                        }
                    });

                    if (all_hidden) {
                        element.classList.add('hidden');
                    }
                    else {
                        element.classList.remove('hidden');
                    }
                });

                let element_count = 0;
                this.querySelectorAll('.pack-list__slide:not(.custom-image, .hidden)').forEach((element) => {
                    element_count++;
                });

                console.log(element_count);

                if (element_count == 1) {
                    document.querySelectorAll('.pluriel').forEach((element) => {
                        element.classList.add('hidden');
                    });
                } else {
                    document.querySelectorAll('.pluriel').forEach((element) => {
                        element.classList.remove('hidden');
                    });
                }

                document.querySelectorAll('[data-nb-products]').forEach((element) => {
                    element.textContent = element_count;
                });

            });



        });
    }

    openFilters() {
        document.body.classList.add('overflow-hidden');
        document.body.classList.add('overflow-hidden-filters');
        document.querySelector('.main-collection__filters').classList.add('actif');
    }




    updateCustomImages() {
        this.querySelectorAll('.main-collection-item').forEach((element) => {
            let nb_items = element.querySelectorAll('.pack-list__slide:not(.custom-image, .hidden)').length;

            let breakpoints = {
                0: 2,
                749: 3,
                990: 2,
                1300: 3
            };

            let currentScreenWidth = window.innerWidth;

            let current_items_line = 0;

            for (let key in breakpoints) {
                if (currentScreenWidth >= parseInt(key)) {
                    console.log(key);
                    current_items_line = breakpoints[key];
                }
            }

            let lines_number = Math.ceil(nb_items / current_items_line);

            let items_remaining = (lines_number * current_items_line) - nb_items;

            console.log(lines_number, current_items_line, nb_items);

            console.log('items remaining : ' + items_remaining);
            if (!element.querySelector('.custom-image')) {
                return;
            }
            if (items_remaining == 1) {
                element.querySelector('.custom-image').classList.remove('hidden');
                element.querySelector('.custom-image').classList.remove('custom-image--two');
                element.querySelector('.custom-image').classList.add('custom-image--one');
            } else if (items_remaining == 2) {
                element.querySelector('.custom-image').classList.remove('hidden');
                element.querySelector('.custom-image').classList.remove('custom-image--one');
                element.querySelector('.custom-image').classList.add('custom-image--two');
            }
            else {
                element.querySelector('.custom-image').classList.remove('custom-image--two');
                element.querySelector('.custom-image').classList.remove('custom-image--one');
                element.querySelector('.custom-image').classList.add('hidden');
            }
        });


    }




    addToCart(productId) {
        const url = "/cart/add.js";
        const data = {
            items: [
                {
                    id: productId,
                    quantity: 1
                }
            ]
        };

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                document.querySelector('side-cart').refreshCart();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
}

customElements.define('main-collection', MainCollection);